import storeManager from '../../store/StoreManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import shapeTypes from '../../constants/ShapeConstants';

const slideUtils = {
    startPosition: -1,
    slideInitialPosition: -1,
    currentArrow: -1,
    startTime: -1,
    slideOffset: 0,
    videoModel: undefined,
    slidesDurationMap: undefined,
    updateAllThumbnails: false,
    hideDescription: false,

    initMap() {
        this.slidesDurationMap = [];
        const currentIndex = storeManager.getState().currentSlide.currentSlideIndex;
        const slides = storeManager.getState().production.slides;
        var i;
        var totalDuration = 0;

        for (i=0; i<slides.length; i++) {
            this.slidesDurationMap.push(totalDuration);

            if (currentIndex == i)
                totalDuration = totalDuration + audioEditorUtils.getSlideWidth(storeManager.getState().currentSlide.model.time);
            else
                totalDuration = totalDuration + audioEditorUtils.getSlideWidth(slides[i].time);
        }
    },
    generateSlideTitle (slides, length = -1) {
        let theSameName = false;
        let slideTitle;
        let tempTitle = 'Slide ';
        let i;
        let slide;

        if (length != -1) {
            if (length == 0)
                length = 1;
            tempTitle = tempTitle + length;
        } else
            tempTitle = tempTitle + (slides.length + 1);

        for (i=0; i<slides.length; i++) {
            slide = slides[i];

            if (slide.title == tempTitle)
                theSameName = true;
        }

        if (theSameName == true)
            slideTitle = this.generateSlideTitle(slides, length + 1);
        else
            slideTitle = tempTitle;

        return slideTitle;
    },
    updateFreehandData(slides) {
        var i, j, k;

        for (i=0; i<slides.length; i++) {
            var shapes = slides[i].content;

            for (j=0; j<shapes.length; j++) {
                if (shapes[j].type == shapeTypes.FREEHAND) {
                    if (shapes[j].isNew)
                        return;

                    this.fixPoints(shapes[j].pathPoints);
                } else
                    if (shapes[j].type == shapeTypes.GROUP)
                        this.parseGroup(shapes[j]);
            }
        }
    },
    parseGroup(group) {
        var shapes = group.shapes;
        var i;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].type == shapeTypes.FREEHAND) {
                if (shapes[i].isNew)
                    return;

                this.fixPoints(shapes[i].pathPoints);
            }
        }
    },
    fixPoints(points) {
        var k;

        for (k=0; k<points.length; k++) {
            points[k].x = Number(points[k].x).toFixed(2);
            points[k].y = Number(points[k].y).toFixed(2);
        }
    }
};

export default slideUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/SlidesUtils.js
 **/